import { createFileRoute } from '@tanstack/react-router';

import { AppEditorPage } from '../features/supply/apps/components/AppEditorPage/AppEditorPage';

export const Route = createFileRoute('/supply/apps_/edit/$appId')({
  component: AppEditRoute,
});

function AppEditRoute() {
  const { appId } = Route.useParams();
  return <AppEditorPage appId={appId} />;
}
